module.exports = __webpack_public_path__ + "img/grand-beach.af9cbfc8.jpg";